/**
 * Pendo event names for Leagues V2. Prefixed so they never collide with the
 * legacy `ClubhouseEvents` league names in Pendo, which are keyed by name.
 * One name per user action; mutation events fire from the tracking middleware
 * on success, view events from `useTrackLeaguesV2View`.
 */
export enum LeaguesV2Events {
  // Views
  VIEW_DASHBOARD = "Leagues V2 - View Dashboard",
  VIEW_CREATE_LEAGUE = "Leagues V2 - View Create League",
  VIEW_EDIT_LEAGUE = "Leagues V2 - View Edit League",
  VIEW_LEAGUE = "Leagues V2 - View League",
  VIEW_ROUND = "Leagues V2 - View Round",
  VIEW_HANDICAP_HISTORY = "Leagues V2 - View Handicap History",
  VIEW_ADJUDICATION_QUEUE = "Leagues V2 - View Adjudication Queue",

  // Create / edit funnel
  SELECT_CREATE_MODE = "Leagues V2 - Select Create Mode",
  VIEW_CREATE_WIZARD_STEP = "Leagues V2 - View Create Wizard Step",
  VIEW_LEAGUE_EDITOR_STEP = "Leagues V2 - View League Editor Step",
  DOWNLOAD_ROSTER_TEMPLATE = "Leagues V2 - Download Roster Template",

  // League
  CREATE_LEAGUE = "Leagues V2 - Create League",
  UPDATE_LEAGUE = "Leagues V2 - Update League",
  FINALIZE_LEAGUE = "Leagues V2 - Finalize League",
  DELETE_DRAFT_LEAGUE = "Leagues V2 - Delete Draft League",

  // Roster
  ADD_ROSTER_MEMBER = "Leagues V2 - Add Roster Member",
  CREATE_ROSTER_MEMBER = "Leagues V2 - Create Roster Member",
  IMPORT_ROSTER = "Leagues V2 - Import Roster",
  UPDATE_ROSTER_MEMBER = "Leagues V2 - Update Roster Member",
  REMOVE_ROSTER_MEMBER = "Leagues V2 - Remove Roster Member",

  // Teams
  CREATE_TEAM = "Leagues V2 - Create Team",
  RENAME_TEAM = "Leagues V2 - Rename Team",
  WITHDRAW_TEAM = "Leagues V2 - Withdraw Team",
  DELETE_TEAM = "Leagues V2 - Delete Team",
  ASSIGN_TEAM_PLAYERS = "Leagues V2 - Assign Team Players",
  REMOVE_TEAM_PLAYER = "Leagues V2 - Remove Team Player",

  // Rounds
  CREATE_ROUND = "Leagues V2 - Create Round",
  UPDATE_ROUND = "Leagues V2 - Update Round",
  DELETE_ROUND = "Leagues V2 - Delete Round",
  FINALIZE_ROUND = "Leagues V2 - Finalize Round",
  RECALCULATE_ROUND_SCORE = "Leagues V2 - Recalculate Round Score",
  SEND_ROUND_TO_SIMULATOR = "Leagues V2 - Send Round To Simulator",
  ASSIGN_SUBSTITUTE = "Leagues V2 - Assign Substitute",

  // Scorecards
  REVIEW_SCORECARD = "Leagues V2 - Review Scorecard",
  RECOVER_ORPHAN_SCORECARDS = "Leagues V2 - Recover Orphan Scorecards",
  EDIT_SCORECARD = "Leagues V2 - Edit Scorecard",
  CREATE_SCORECARD = "Leagues V2 - Create Scorecard",
}
